import { ISO_4217 } from "../../iso-4217";
import { event, GtagEvent } from "./event";

export interface QualifyLead extends GtagEvent {
    currency:ISO_4217;
    value: number;
}
export const qualify_lead = ($_:QualifyLead) => event('qualify_lead',$_);